import React from 'react';
import IconButton from 'components/common/IconButton';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import y from 'y4/Utils';

const CopyButton = ({ product }) => {
  const { t } = useTranslation('commerce');
  return !product.clipboard ? null : (
    <p className="fs--1 mt-3">
      <IconButton
        className="border-300"
        iconClassName="me-1"
        variant="outline-info"
        size="sm"
        icon={['far', 'copy']}
        onClick={() => {
          const el = document.createElement('textarea');
          el.value = product.clipboard;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          y.toast(t('Product info copied to clipboard'), { type: 'success' });
        }}
      >
        <Trans ns="commerce">Copy product</Trans>
      </IconButton>
    </p>
  );
};

CopyButton.propTypes = {
  product: PropTypes.object.isRequired
};

export default CopyButton;
